import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

/**
 * `columns` é uma lista de { header, accessor } onde accessor pode ser uma
 * string (chave da linha) ou uma função (row) => valor já formatado.
 */
const buildMatrix = (rows, columns) =>
  rows.map(row =>
    columns.map(column =>
      typeof column.accessor === 'function' ? column.accessor(row) : row[column.accessor]
    )
  )

export const exportToExcel = (rows, columns, fileName, sheetName = 'Dados') => {
  const body = rows.map(row => {
    const item = {}
    columns.forEach(column => {
      item[column.header] =
        typeof column.accessor === 'function' ? column.accessor(row) : row[column.accessor]
    })
    return item
  })
  const worksheet = XLSX.utils.json_to_sheet(body)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31))
  XLSX.writeFile(workbook, `${fileName}.xlsx`)
}

export const exportToCsv = (rows, columns, fileName) => {
  const header = columns.map(column => column.header)
  const matrix = buildMatrix(rows, columns)
  const escape = value => {
    const text = value === null || value === undefined ? '' : String(value)
    return `"${text.replace(/"/g, '""')}"`
  }
  const csv = [header, ...matrix].map(line => line.map(escape).join(';')).join('\r\n')
  // BOM para o Excel reconhecer acentuação.
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${fileName}.csv`
  link.click()
  URL.revokeObjectURL(link.href)
}

export const exportToPdf = (rows, columns, fileName, title) => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt' })
  doc.setFontSize(14)
  doc.text(title || fileName, 40, 40)
  doc.setFontSize(9)
  doc.text(`Gerado em ${new Date().toLocaleString('pt-BR')}`, 40, 56)
  autoTable(doc, {
    head: [columns.map(column => column.header)],
    body: buildMatrix(rows, columns),
    startY: 72,
    styles: { fontSize: 8, cellPadding: 4 },
    headStyles: { fillColor: [61, 93, 132] },
  })
  doc.save(`${fileName}.pdf`)
}
